<!-- eslint-disable -->
<template>
    <div id="onlinestate" style="min-width: 1280px;">
      <div class="row align-items-start pb-2 pt-2">  
        <div class="col-1 d-flex justify-content-end label__adjust">
          Jahr: 
        </div>
        <div class="col-1 d-flex justify-content-start">            
             <select class="form-select select__max" v-model="selectedYear" @change="getSelectedYear">
                <option v-for="(item , idYear) in years" v-bind:key="idYear">
                  {{item.year}}
                </option>
              </select>      
        </div>
        <div class="col-1">        
          <button
            type="button"
            @click.prevent="onButtonRefresh"
            class="btn btn-outline-primary same__size btn-sm"
          >
          Anzeigen
          </button>
        </div>
  
        <div class="col-1">
          <span v-if="selectCount==1">
            {{selectedBereich}}
          </span>
          <span v-if="selectCount!=1">
            &nbsp;&nbsp;&nbsp;Sel.: {{selectCount}}
          </span>
  
        </div>
  
        <div class="col-1">
          <button
            type="button"
            @click.prevent="onButtonEmergencyDataCreate"
            class="btn btn-outline-primary same__size btn-sm"
            :disabled="isActionPossible()"
          >
          Rett.erzeugen
          </button>
        </div>
  
        <div class="col-1">
          <button
            type="button"
            @click.prevent="onButtonEmergencyData"
            class="btn btn-outline-primary same__size btn-sm"
            :disabled="isActionPossible()"
          >
          Rett.senden
          </button>
        </div>
  
  
        <div class="col-1">
          <button
            type="button"
            @click.prevent="onButtonCreateRequisition"
            class="btn btn-outline-primary same__size btn-sm"
            :disabled="isActionPossible()"
          >
          Best.erzeugen
          </button>
        </div>
  
        <div class="col-1">
          <button
            type="button"
            @click.prevent="onButtonShipRequisition"
            class="btn btn-outline-primary same__size btn-sm"
            :disabled="isActionPossible()"
          >
          Best.senden
          </button>
        </div>
  
  
        <div class="col-1">
          <button
            type="button"
            @click.prevent="onButtonCreateInvoice"
            class="btn btn-outline-primary same__size btn-sm"
            :disabled="isActionPossible()"
          >
          Rech.erzeugen
          </button>
        </div>
  
        <div class="col-1">
          <button
            type="button"
            @click.prevent="onButtonShipInvoice"
            class="btn btn-outline-primary same__size btn-sm"
            :disabled="isActionPossible()"
          >
          Rech.senden
          </button>
        </div>  
      </div>

      <div class="col-1">
        <button
          type="button"
          @click.prevent="onButtonCreateReminder"
          class="btn btn-outline-primary same__size"
          :disabled="isActionPossible()"
        >
        Mahnung.erzeugen
        </button>
      </div>

      <div class="col-1">
        <button
          type="button"
          @click.prevent="onButtonShipReminder"
          class="btn btn-outline-primary same__size"
          :disabled="isActionPossible()"
        >
        Mahnung.senden
        </button>
      </div>

      <div class="row align-items-start pb-2 pt-2">  
        <div class="col-1 d-flex justify-content-end label__adjust">
          Mandant: 
        </div>
        <div class="col-2 d-flex justify-content-start">            
            <select class="form-select select__max-mandant" v-model="selectedMandant" @change="getSelectedMandant">
                <option v-for="(item , idMandant) in mandants" v-bind:key="idMandant">
                  {{item.mandant}}
                </option>
              </select>      
        </div>     
        <div class="col-1">        
          <button
            type="button"
            @click.prevent="onButtonCalculateReminders"
            class="btn btn-outline-primary same__size left_offset"
          >
          Mahnungslauf
          </button>
        </div>
      </div>
  

      <div class="row align-items-start pb-2">
        <div clas="col-12">
          <rechnung-detail :customerLink="customerLink" :Year="selectedYear" :standAlone="documentStandAlone" :onLoading="loading" />
        </div>
      </div>
  
      <div class="row align-items-start pb-2">
        <div clas="col-12" style="padding-left: 20px;">
          <Grid
            ref="grid"
            :style="{ height: '900px' }"
            :selected-field="selectedField"
            :data-items="filteredData"
            :columns="columns"
            :filterable="true"
            :filter="filter"
            :sortable="true"
            :sort="sort"
            @selectionchange="onSelectionChange"
            @headerselectionchange="onHeaderSelectionChange"
            @rowclick="onRowClick"
            @filterchange="filterChange"
            @sortchange="sortChange"
            @custom="customHandler"          
          >
            <template v-slot:checkBoxColumn="{ props }">
              <td style="text-align: center;">              
                <input type="checkbox" v-model="props.dataItem.bezahlt"
                @click="onCheckClick(props.dataItem)" 
                />
              </td>
            </template>             
            <template v-slot:bestellungPrint="{ props }">
              <td style="text-align: center;">
                <button type="button"
                 @click.prevent="onBestellungDownload(props.dataItem)"
                  class="btn btn-outline-primary btn-sm" >
                    Anzeigen
                </button>
              </td>
            </template>
            <template v-slot:rechnungPrint="{ props }">
              <td style="text-align: center;">
                <button type="button"
                 @click.prevent="onRechnungDownload(props.dataItem)"
                  class="btn btn-outline-primary btn-sm">
                    Anzeigen
                </button>
              </td>
            </template>
            <template v-slot:actionColumn="{ props }">
              <td style="text-align: center;">
                <button type="button"
                 @click.prevent="onActionClick(props.dataItem)"
                  class="btn btn-outline-primary btn-sm">
                    Details
                </button>
              </td>
            </template>
            <template v-slot:myTemplate="{ props }">
              <rechnung-detail :data-item="props.dataItem" />
            </template>
          </Grid>
        </div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, ref } from "vue";
  import { AsyncRestClient } from '@/infrastructure/backend/async/AsyncRestClient';
  import { Grid } from "@progress/kendo-vue-grid";
  import { filterBy, orderBy, SortDescriptor } from "@progress/kendo-data-query";  
  import RechnungDetail from "./RechnungDetail.vue";
  import { computed } from "@vue/reactivity";
  import { Identity } from "@/infrastructure/backend/userIdentity";
  import { Out } from "@/infrastructure/frontent/clientMessage";
  
import { serializeToJson } from "@/functional/datetimehelper";
import { deepClone } from "@/infrastructure/functional/deepClone";


  export default defineComponent({
  name: "RechnungsDashboard",
  components: {
    Grid,
    RechnungDetail,
  },
  setup() {

      const defaultFilteredData: any = undefined
      const defaultFilter: any = undefined

      let currentSelectedItem: any = {}
      const selectCount = ref(0)
      const selectedBereich = ref("")
      const documentStandAlone = ref(false)
      const loading = ref(true)
      const customerLink= ref("-")
      const overwrite= ref(false)
      const selectedYear= ref(2026)
      const selectedMandant = "02 SOS24Aid-Süd"
      const mandants = [
        {idMandant:1073741838 , mandant: '01 SOS24Aid-Nord'},
        {idMandant:1073741959 , mandant: '02 SOS24Aid-Süd'}
      ]
      let selected: any = {}
      const years= ref( [
        {idYear: 1, year: 2021},
        {idYear: 2, year: 2022},
        {idYear: 3, year: 2023},
        {idYear: 4, year: 2024},
        {idYear: 5, year: 2025},
        {idYear: 6, year: 2026}
      ])
      const filter= ref(defaultFilter)
      const sort = ref<SortDescriptor[]>([
        { field: "nameMandant", dir: "asc" },
        { field: "nameBereich", dir: "asc" },
        { field: "bereichGruppierung", dir: "asc" }
      ])
      const selectedField= ref("selected")
      const filteredData= ref(defaultFilteredData)
      const originData= ref([])
      const staticColumns= ref([ 
        { field: 'kundenLink', title: 'Kunden-Link',  width:'100px',  filterable: false, hidden: false, cell: "actionColumn" },
        { field: 'nameMandant', title: 'Mandant',  width:'220px' },
        { field: 'idBereich', title: 'Bestellung', width:'100px',  filterable: false, hidden: false, cell: "bestellungPrint" },
        { field: 'idMandant', title: 'Rechnung', width:'100px',  filterable: false, hidden: false, cell: "rechnungPrint" },
        { field: 'nameBereich', title: 'Bereich',  width:'220px' },
        { field: 'status', title: 'Status',  width:'120px' },
        { field: 'vorgangTyp', title: 'Typ',  width:'120px' },
        { field: 'versandArt', title: 'Versandart',  width:'120px' },
        { field: 'rechnungsBetrag', title: 'Betrag' ,filterable: false, sortable: false, width:'100px' },
        { field: 'bezahlt', title: 'Bezahlt', cell: "checkBoxColumn", filterable: false, width:'100px' },
        { field: 'hauptNameBereich', title: 'Haupt-Bereich',  width:'180px', hidden: true },
        { field: 'emailKundeBereich', title: 'Email-Kunde',  width:'180px' },
        { field: 'emailFakturaBereich', title: 'Email-Faktura',  width:'180px' },
        { field: 'kundeGruppen', title: 'Kunde-Gruppe',  width:'180px' },
        { field: 'fakturaGruppen', title: 'Faktura-Gruppe',  width:'180px' },
        { field: 'kundeNutzerprofil', title: 'Kunde-Nutzerprofil',  width:'180px' },
        { field: 'fakturaNutzerProfil', title: 'Faktura-NutzerProfil',  width:'180px' },
        { field: 'idVorgang', title: 'IdVorgang', filterable: false, hidden: true },
        { field: 'fkVorgangsTypCodeVerzeichnis', title: 'fkVorgangsTypCodeVerzeichnis', filterable: false, hidden: true },
        { field: 'jahr', title: 'Jahr',  width:'300px', hidden: true },
        { field: 'datumZeitLetzterKundenZugriff', title: 'Letzter Kundenzugriff', filterable: true, width:'180px' },
        { field: 'datumZeitErzeugung', title: 'DatumZeitErzeugung', filterable: true, width:'180px', hidden: true },
        { field: 'datumZeitBestellanfrageErzeugung', title: 'Bestellanfrage erzeugt', filterable: true, width:'180px' },
        { field: 'datumZeitLetzteBestellanfrageVersand', title: 'Bestellanfrage versand', filterable: true, width:'180px' },
        { field: 'datumZeitBestellnummerVerfuegbar', title: 'Bestellnummer verfuegbar', filterable: true, width:'180px' },
        { field: 'datumZeitRechnungErzeugt', title: 'Rechnung erzeugt', filterable: true, width:'180px' },
        { field: 'datumZeitRettungsdatenErzeugt', title: 'Rettungsdaten erzeugt', filterable: true, width:'180px' },
        { field: 'datumZeitLetzterRechnungVersand', title: 'Rechnung versand', filterable: true, width:'180px' },
        { field: 'bemerkung', title: 'Bemerkung',  width:'300px' },
        { field: 'fkHauptBereich', title: 'fkHauptBereich', filterable: false, hidden: true },
        { field: 'fkSprachCodeTabelle', title: 'fkSprachCodeTabelle', filterable: false, hidden: true },
        { field: 'Sprache', title: 'Sprache', filterable: true, width:'180px' },
        { field: 'fkDokumentVersandArtCodeVerzeichnis', title: 'fkDokumentVersandArtCodeVerzeichnis', filterable: false, hidden: true },
        { field: 'kundePersonen', title: 'KundePersonen', width:'180px' ,filterable: false, hidden: true},
        { field: 'fakturaPersonen', title: 'FakturaPersonen',  width:'180px',  filterable: false, hidden: true },       
      ])

      const areAllSelected = computed( () => {
        try {
          if (filteredData.value === undefined || filteredData.value.length == 0) {
            return false;
          }
          return filteredData.value.findIndex((item: any) => item.selected === false) === -1        
        } catch (e) {
          Out.error(e);
        }
        return false;       
      })
      const columns = computed( (): any => {
        return [
          {
            field: "selected",
            width: "50px",
            filterable: false,
            //headerSelectionValue: areAllSelected ?? false,
          },
          ...staticColumns.value,
        ];
      })

 
   async function setBezahlt(item: any) {
      let client = AsyncRestClient.Create(true);
      if (client.isFailure) return;
      const result = await client
          .getValue()
          .exchangeForComponents<string, any>(process.env.VUE_APP_API + "api/rechnung/setBezahlt", 
              serializeToJson({
                userId: Identity.getIdentity().getValue().UserId,
                bezahlt: item.bezahlt,
                idBereich: item.idBereich,
      }));
      if (result.isFailure) return; 
      refreshCustomerLinks();
    }

  
    const refreshCustomerLinks = () => {
        if(! currentSelectedItem && !currentSelectedItem.kundenLink.value) {
          return;
        }

        if (customerLink.value && customerLink.value.indexOf("###") >= 0) {
          customerLink.value = currentSelectedItem.kundenLink.replace("###", "");
          return
        } 
        customerLink.value = currentSelectedItem.kundenLink + "###";             
    }

    const isActionPossible = () => {    
      if ( new Date().getFullYear() == selectedYear.value) return false;
        return true;
    }

    const onCheckClick = (item: any) => {
      item.bezahlt = !item.bezahlt;
      setBezahlt(item);
    }

    function selectionChanged( event: any ) {
      selectCount.value = 0;
      selectedBereich.value = "";
      if ( event.dataItem[selectedField.value] !== undefined) {
        event.dataItem[selectedField.value] = !event.dataItem[selectedField.value];
      }
      else {
        event.dataItem[selectedField.value] = true;
      }

      if (selected === undefined) {
        selected.records = [];
      }

      if (selected.records === undefined) {
        selected.records = [];
      }

      let i = 0;
      selected.records.value = [];
      filteredData.value.forEach((item: any) => {
        if (item.selected === true) {
          selected.records.push(item);
          i = i + 1;
        }
      });
      selectCount.value = i;
      if (i == 1) {
         selectedBereich.value = selected.records[0].nameBereich;
      }
      else {
        selectedBereich.value ="";
      }
    }

    const onButtonCalculateReminders = () => {calculateReminders();}
    const openLink = (link: string) => {window.open(link, "_blank");}
    const customHandler = (e: any) => { Out.noOperation();}

    const created = () => {selected.records = [];}

    async function calculateReminders() {      
      let client = AsyncRestClient.Create(true);
      if (client.isFailure) return;
      const result = await client
          .getValue()
          .exchangeForComponents<string, any>(process.env.VUE_APP_API + "api/rechnung/calculateReminders", 
              serializeToJson({
        userId: Identity.getIdentity().getValue().UserId,
        year: selectedYear.value,
        Year: 2026,
        NameMandant: selectedMandant,
      }));
      if (result.isFailure) return;
    }

    async function createCustomerReports(action: string) {
        const docFilePath = process.env.VUE_APP_FILEPATH;
        const docUrl = process.env.VUE_APP_DOCUMENTURL;
        const customerLink = process.env.VUE_APP_CUSTOMERLINKURL;

        let client = AsyncRestClient.Create(true);
        if (client.isFailure) return;
        const result = await client
            .getValue()
            .exchangeForComponents<string, any>(process.env.VUE_APP_API + "api/rechnung/createCustomerReports", 
                serializeToJson({
          userId: Identity.getIdentity().getValue().UserId,
          year: selectedYear.value,
          overwrite: overwrite.value,
          action: action,
          documentFilePath: docFilePath,
          documentUrl: docUrl,
          records: selected.records,
          CustonerLinkBasePath: customerLink
        }));
        if (result.isFailure) return; 

        refreshCustomerLinks();
      }

      async function createCustomerPaperDocument(record: any, documentType: any, action : string,  printerName: string) {
      
        const docFilePath = process.env.VUE_APP_FILEPATH;
        const docUrl = process.env.VUE_APP_DOCUMENTURL;        
        let records = [];
        records.push(record);

        let client = AsyncRestClient.Create(true);
        if (client.isFailure) return;
        const result = await client
            .getValue()
            .exchangeForComponents<string, any>(process.env.VUE_APP_API + "api/rechnung/createCustomerPaperDocuments", 
                serializeToJson({
          userId: Identity.getIdentity().getValue().UserId,
          year: selectedYear.value,
          action: action,
          documentFilePath: docFilePath,
          documentUrl: docUrl,
          documentType: documentType,
          print: false,
          printerName: printerName,
          records: records,
        }));
        if (result.isFailure) return; 
        let temp = deepClone(result.getValue());
        refreshCustomerLinks();
        setTimeout(() => { openLink(temp.documentUrl) }, 100);
    }


    async function createCustomerPaperDocuments(documentType: any, action: string, isPrint: boolean, printerName: string) {
      
        const docFilePath = process.env.VUE_APP_FILEPATH;
        const docUrl = process.env.VUE_APP_DOCUMENTURL;

        let client = AsyncRestClient.Create(true);
        if (client.isFailure) return;
        const result = await client
            .getValue()
            .exchangeForComponents<string, any>(process.env.VUE_APP_API + "api/rechnung/createCustomerPaperDocuments", 
                serializeToJson({
          userId: Identity.getIdentity().getValue().UserId,
          year: selectedYear.value,
          action: action,
          documentFilePath: docFilePath,
          documentUrl: docUrl,
          documentType: documentType,
          print: isPrint,
          printerName: printerName,
          records: selected.records,
        }));
        if (result.isFailure) return;      
 
        refreshCustomerLinks();
    }

    async function getData() {
      loading.value = true
      selectCount.value = 0;
      selectedBereich.value = "";

      let client = AsyncRestClient.Create(true);
        if (client.isFailure) return;
        const result = await client
            .getValue()
            .exchangeForComponents<string, any>(process.env.VUE_APP_API + "api/rechnung/customerProcesses", 
                serializeToJson({
                userId: Identity.getIdentity().getValue().UserId,
                year: selectedYear.value,
                overwrite: overwrite.value,
                action: "view",
        }));
        if (result.isFailure) return; 
        let temp = deepClone(result.getValue());


      filteredData.value = temp.map((item: any) => {
        return { ...item };
      });
      originData.value = temp.map((item: any) => {
        return { ...item };
      });


      filteredData.value = filterBy(originData.value, filter.value);
      filteredData.value = orderBy(filteredData.value, sort.value);
    
    }

    const onActionClick = (item: any) => {
      try {
        loading.value = false
        if ( customerLink.value.indexOf("###") >= 0) {
          customerLink.value = item.kundenLink.replace("###", "");
        } else {
        customerLink.value = item.kundenLink + "###";
        }
        currentSelectedItem = item;
      }
      catch(e) {
        Out.error(e);
      }
    }

    const getSelectedYear = () => {console.log(selectedYear.value);}
    const getSelectedMandant = () => {console.log(selectedMandant);}
    const getOverWrite = () => { overwrite.value = !overwrite.value }

    const filterChange = (ev: any) => {
      selectCount.value = 0;
      selectedBereich.value = "";
      filter.value = ev.filter;
      filteredData.value = filterBy(originData.value, filter.value);
    }

    const filterRender = (h: any, defaultRendering: any , props: any, change: any) => {
      return defaultRendering;
    }

    const sortChange = (e: any) => {
      sort.value = e.sort;
      filteredData.value = orderBy(filteredData.value, sort.value);
    }



    const onBestellungDownload = (item: any) => {
      createCustomerPaperDocument(item,270, "Bestellung_Papier", "Snagit 2021" );
    }

    const onRechnungDownload = (item: any) => {
      createCustomerPaperDocument(item,271, "Rechnung_Papier", "Snagit 2021" );
    }

    const onButtonRefresh = () => {
      getData();
    }

    const onButtonCreateRequisition = () => {
      createCustomerReports("BANF erzeugen");      
    }

    const onButtonShipRequisition = () => {
      createCustomerReports("EMail.Bestellanforderung");
    }

    const  onButtonCreateInvoice = ()  => {
      createCustomerReports("Rechnung erzeugen");
      //createCustomerPaperDocuments(271,"RechnbungPapier" , true, "Microsoft Print to PDF");
    }

    const onButtonShipInvoice = () => {
      createCustomerReports("EMail.Rechnung");
    }

    const onButtonCreateReminder = () => {
      createCustomerReports("Mahnung erzeugen");
    }

    const onButtonShipReminder = () => {
      createCustomerReports("EMail.Mahnung");
    }

    const onButtonEmergencyData = () => {
      createCustomerReports("EMail.Rettungsdaten");      
    }

    const onButtonEmergencyDataCreate = () => {
      createCustomerReports("Rettungsdaten.Erzeugen"); 
    }

    function onHeaderSelectionChange(event: any) {
      selectCount.value = 0;
      selectedBereich.value = "";
      let checked = event.event.target.checked;      
      filteredData.value = filteredData.value.map((item: any) => {
        return { ...item, selected: checked };
      });
      selected.records = []
      let i = 0;
      filteredData.value.forEach((item: any) => {
        if (item.selected === true) {
          selected.records.push(item);
          i = i + 1;
        }
      });
      selectCount.value = i;
      if (i == 1) {
         selectedBereich.value = selected.records[0].nameBereich;
      }
      else {
        selectedBereich.value ="";
      }

    }
    
    const onSelectionChange = (event: any) => {
      if (!event || !event.dataItem) return

      selectionChanged(event);
    }

    const onRowClick = (event: any) => {
      //customerLink = event.dataItem.kundenLink;
      //selectionChanged(event);
    }

    return {
      mandants,
      selectedMandant,
      areAllSelected,
      columns,
      selectedField,
      filteredData,
      originData,
      staticColumns,
      currentSelectedItem ,
      selectCount,
      selectedBereich,
      documentStandAlone,
      customerLink,
      overwrite,
      selectedYear,
      selected,
      years,
      filter,
      sort,
      created,
      customHandler,
      createCustomerReports,
      createCustomerPaperDocument,
      createCustomerPaperDocuments,
      setBezahlt,
      refreshCustomerLinks,
      isActionPossible,
      getSelectedYear,
      getSelectedMandant,
      getOverWrite,
      filterChange,
      sortChange,
      openLink,
      filterRender,
      onCheckClick,
      onActionClick,
      onBestellungDownload,
      onRechnungDownload,
      onButtonRefresh,
      onButtonCreateRequisition,
      onButtonShipRequisition,
      onButtonCreateInvoice,
      onButtonShipInvoice,
      onButtonCreateReminder,
      onButtonShipReminder,
      onButtonEmergencyData,
      onButtonEmergencyDataCreate,
      onHeaderSelectionChange,
      onSelectionChange,
      onRowClick,
      onButtonCalculateReminders,
      loading
    }
    }
  });
</script>
  
  <style scoped language="scss">

  
  .select__max {
    max-width: 100px;
    min-width: 100px;
    max-height: 32px;
    font-size: 0.8rem;
  }
  
  .label__adjust {
    margin-top: 5px;
  }
  
  .form-switch {
      border-radius: 2em;
      height: 25px;
      width: 25px;
  }
  
  .checkbox__adjust{
    margin-top: 3px;
  }
  
  .same__size {
    min-width: 105px;
    padding-left: 5px;
    padding-right: 5px;
  }
  
  </style>